import { LignePanier } from './ligne-panier.model';

export class Panier {
  
  libelle: string;
  montantFraisDePort: number;
  montantTotal: number;
  montantTotalHT: number;
  lignePanier: Array<LignePanier>;

}



// WEBPACK FOOTER //
// ./src/app/shared/models/panier.model.ts